import { Component } from '@angular/core';
import { SubNavBaseComponent } from '@app/menu/components/sub-nav-base-component';

@Component({
  selector: 'portal-enterprise-calendar-sub-nav',
  templateUrl: './enterprise-calendar-sub-nav.component.html',
  standalone: false,
})
export class EnterpriseCalendarSubNavComponent extends SubNavBaseComponent {}
